import { render, staticRenderFns } from "./PerMeal.vue?vue&type=template&id=30d18056&scoped=true&"
import script from "./PerMeal.vue?vue&type=script&lang=js&"
export * from "./PerMeal.vue?vue&type=script&lang=js&"
import style0 from "./PerMeal.vue?vue&type=style&index=0&id=30d18056&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d18056",
  null
  
)

export default component.exports